import { useSyncExternalStore } from "react";

export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (cb) => {
      const mq = window.matchMedia(query);
      mq.addEventListener("change", cb);
      return () => mq.removeEventListener("change", cb);
    },
    () => window.matchMedia(query).matches,
    () => false,
  );
}

/** Two-pane chat from Tailwind's `lg` (1024 px) — the project's desktop breakpoint for account pages. */
export const useIsDesktop = () => useMediaQuery("(min-width: 1024px)");

export const usePrefersReducedMotion = () => useMediaQuery("(prefers-reduced-motion: reduce)");

export const useIsTouch = () => useMediaQuery("(pointer: coarse)");
